import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { useRetrieveTransferRequest } from "../api/TransferRequestApiProvider";
import { useRetrieveTeam } from "../ApiProvider";
import { UserContext } from "../auth/UserProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { ManagerTransferRequestView } from "./ManagerTransferRequestView";
import { PlayerTransferRequestView } from "./PlayerTransferRequestView";
export const TransferRequest = () => {
    const { id } = useNumericParams();
    const { data: transferRequest, error, isLoading, } = useRetrieveTransferRequest({ id });
    const teamId = transferRequest?.team;
    const { data: team, error: teamError, isLoading: teamIsLoading, } = useRetrieveTeam({ id: teamId });
    const { user: contextUser, loading: isContextUserLoading } = useContext(UserContext);
    if (isLoading || (!!teamId && teamIsLoading) || isContextUserLoading) {
        return _jsx(Loading, {});
    }
    if (error || !transferRequest || teamError || !team || !contextUser) {
        return _jsx(ErrorView, { error: error || teamError });
    }
    if (contextUser.pk === team.createdBy) {
        return (_jsx(ManagerTransferRequestView, { transferRequest: transferRequest, team: team }));
    }
    return (_jsx(PlayerTransferRequestView, { transferRequest: transferRequest, team: team }));
};
